export namespace paymentTypes {
  export type Payment = {
    _id: string;
    amount: number;
    currency: string;
    client_details: string;
    payment_method: string;
    date: string;
    source: string;
  };

  export type GetPayments = () => Promise<{ payments: Payment[] }>;
}
